<template>
  <div class="error">
    <h1 class="page-title">页面不存在</h1>
  </div>
</template>

<script>
export default {
  name: 'Error404'
};
</script>

mView.showProgress();
mView.closeProgress();
